import React from "react"
import { View, Window, Text, Button } from "react-ame-components"

export class ViewExample extends React.Component {
  render() {
    return (
      <Window>
        <View
          padding="large"
          dataCy="view-test">
          <Text target="title">View</Text>
        </View>
        <View
          marginTop="extra-large"
          flexWrap="wrap"
          padding="large">
          <View
            padding="large"
            justify="center"
            align="center"
            shadow="level-2"
            dataCy="view-shadow">
            <Text>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
              elementum mauris vel lacus ultricies finibus. Donec id metus
              magna. Nam eu lobortis ipsum. Aliquam erat volutpat. Maecenas
              tincidunt molestie sapien, quis rutrum leo tristique eget.
              Pellentesque pretium eu diam sed elementum. Integer in pharetra
              ipsum, non ullamcorper arc.
            </Text>
          </View>
          <View
            marginTop="medium"
            padding="large"
            justify="center"
            align="center"
            borderColor="neutral-700"
            borderWidth="hairline"
            borderRadius="small"
            backgroundColor="neutral-300"
            dataCy="view-border">
            <Text>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
              elementum mauris vel lacus ultricies finibus. Donec id metus
              magna. Nam eu lobortis ipsum. Aliquam erat volutpat. Maecenas
              tincidunt molestie sapien, quis rutrum leo tristique eget.
              Pellentesque pretium eu diam sed elementum. Integer in pharetra
              ipsum, non ullamcorper arcu.
            </Text>
          </View>
          <View
            padding="large"
            justify="center"
            align="center"
            backgroundColor="primary"
            borderWidth="hairline"
            borderRadius="small"
            borderColor="none"
            marginTop="medium"
            dataCy="view-margin-padding">
            <Text color="background">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
              elementum mauris vel lacus ultricies finibus. Donec id metus
              magna. Nam eu lobortis ipsum. Aliquam erat volutpat. Maecenas
              tincidunt molestie sapien, quis rutrum leo tristique eget.
              Pellentesque pretium eu diam sed elementum. Integer in pharetra
              ipsum, non ullamcorper arcu.
            </Text>
          </View>
          <View
            padding="large"
            justify="center"
            align="center"
            backgroundColor="secondary"
            borderWidth="hairline"
            borderRadius="small"
            borderColor="none"
            marginTop="medium"
            dataCy="view-backgroundColor">
            <Text color="background">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
              elementum mauris vel lacus ultricies finibus. Donec id metus
              magna. Nam eu lobortis ipsum. Aliquam erat volutpat. Maecenas
              tincidunt molestie sapien, quis rutrum leo tristique eget.
              Pellentesque pretium eu diam sed elementum. Integer in pharetra
              ipsum, non ullamcorper arcu.
            </Text>
          </View>
          <View
            padding="large"
            backgroundColor="error"
            height="150px"
            borderWidth="hairline"
            borderRadius="small"
            borderColor="none"
            marginTop="medium"
            direction="column"
            align="center"
            justify="between"
            dataCy="view-test-flex">
            <Text
              fontWeight="bold"
              color="neutral-300">
              Uma mensagem de erro!
            </Text>
            <Button
              type="primary"
              text="Seguir"
            />
          </View>
          <View
            padding="large"
            backgroundColor="error"
            borderWidth="hairline"
            borderRadius="small"
            borderColor="none"
            marginTop="medium"
            opacity="light"
            dataCy="view-opacity">
            <Text
              fontWeight="bold"
              color="neutral-300">
              Uma mensagem de erro com opacidade light!
            </Text>
          </View>
          <View
            height="200px"
            padding="large"
            backgroundColor="primary"
            borderWidth="hairline"
            borderRadius="small"
            borderColor="none"
            marginTop="medium"
            overflowY="scroll"
            dataCy="view-overflow">
            <Text
              fontWeight="bold"
              color="neutral-300">
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Consequuntur possimus voluptas beatae quaerat? Sapiente, rerum
              odio, consectetur provident nobis quam laudantium id temporibus
              libero suscipit accusamus velit ex rem voluptates! Lorem ipsum
              dolor sit, amet consectetur adipisicing elit. Pariatur illo amet
              quibusdam eos quae debitis reprehenderit iure alias asperiores
              dolor, nemo assumenda deleniti error nam saepe molestiae
              voluptate, illum dolorum? Lorem ipsum dolor sit amet consectetur
              adipisicing elit. Dolorem quo cupiditate delectus illo fuga eum
              provident rerum natus maiores accusamus sunt enim alias, eaque
              doloribus repellat ipsum commodi voluptatem eligendi?
            </Text>
          </View>
          <View
            marginTop="large"
            padding="large"
            justify="center"
            align="center"
            borderColor="neutral-700"
            borderWidth="hairline"
            borderRadiusLeftTop="medium"
            borderRadiusRightTop="none"
            borderRadiusLeftBottom="none"
            borderRadiusRightBottom="medium"
            backgroundColor="neutral-300"
            dataCy="view-border">
            <Text>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
              elementum mauris vel lacus ultricies finibus. Donec id metus
              magna. Nam eu lobortis ipsum. Aliquam erat volutpat. Maecenas
              tincidunt molestie sapien, quis rutrum leo tristique eget.
              Pellentesque pretium eu diam sed elementum. Integer in pharetra
              ipsum, non ullamcorper arcu.
            </Text>
          </View>
        </View>
      </Window>
    )
  }
}
